import { motion } from 'framer-motion';
import { ExternalLink, Vote } from 'lucide-react';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { Section, SectionHeader } from '@/components/ui/Section';
import { Button } from '@/components/ui/button';
import { voteConfig } from '@/config/site';

function VoteCard({ vote, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="p-6 rounded-xl border border-border bg-card/50 backdrop-blur-sm hover:border-primary/30 hover:shadow-lg transition-all"
    >
      <div className="flex flex-col h-full">
        <div className="flex items-center gap-4 mb-4">
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
            <Vote className="h-6 w-6 text-primary" />
          </div>
          <div>
            <h3 className="font-display font-semibold text-foreground">
              {vote.name}
            </h3>
          </div>
        </div>

        <p className="text-sm text-muted-foreground mb-6 flex-grow">
          {vote.description}
        </p>

        <Button
          asChild
          className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold"
        >
          <a
            href={vote.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2"
          >
            Vote Now
            <ExternalLink className="h-4 w-4" />
          </a>
        </Button>
      </div>
    </motion.div>
  );
}

export default function VotePage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-16">
        <Section>
          <SectionHeader
            subtitle="Support Us"
            title="Vote untuk Server"
            description="Bantu Hytale Indonesia naik peringkat dengan memberikan vote kamu. Setiap vote sangat berarti untuk komunitas kita!"
          />

          {/* Info Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-2xl mx-auto mb-12 p-6 rounded-xl border border-primary/30 bg-primary/5"
          >
            <h3 className="font-display font-semibold text-foreground mb-2 text-center">
              Kenapa Vote Penting?
            </h3>
            <p className="text-sm text-muted-foreground text-center">
              Dengan vote, kamu membantu server kami menjadi lebih terlihat di
              listing server. Ini membantu lebih banyak pemain Indonesia menemukan
              komunitas kita!
            </p>
          </motion.div>

          {/* Vote Links Grid */}
          <div className="max-w-md mx-auto">
            {voteConfig.map((vote, index) => (
              <VoteCard key={vote.id} vote={vote} index={index} />
            ))}
          </div>

          {/* No votes available message */}
          {voteConfig.length === 0 && (
            <div className="text-center py-12">
              <Vote className="h-16 w-16 text-muted-foreground/30 mx-auto mb-4" />
              <h3 className="font-display text-xl font-semibold text-foreground mb-2">
                Vote Links Coming Soon
              </h3>
              <p className="text-muted-foreground">
                Kami sedang menyiapkan link vote. Stay tuned!
              </p>
            </div>
          )}
        </Section>
      </main>
      <Footer />
    </div>
  );
}
